import { StyleSheet } from 'react-native';

import { THEME } from 'reactor/common';
import { C } from 'common';

const {
  BORDER_RADIUS, COLOR, UNIT,
} = THEME;

const { LAYOUT: { CONTENT } } = C;


export default StyleSheet.create({
  container: {
    marginBottom: UNIT * 2,
    width: '100%',
    overflow: 'scroll',
  },

  containerMobile: {
    width: 'calc(100% + 20px)',
  },

  content: {
    backgroundColor: COLOR.WHITE,
  },

  contentMobile: {
    width: CONTENT.MAX_WIDTH,
  },

  border: {
    borderColor: COLOR.BASE,
    borderWidth: UNIT * 0.1,
    borderRadius: BORDER_RADIUS,
  },

  shadow: {
    ...THEME.ELEVATION.SMALL,
    borderRadius: BORDER_RADIUS,
  },
});
